import React from 'react';
import { Box, Button, Typography } from '@mui/material';
 
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
const VARIANT_STYLE = {
  disabled: {
    background: '#f8f3fa',
    color: '#bdbdbd',
    border: 'none',
    fontWeight: 400,
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  enabled: {
    background: '#f8f3fa',
    color: '#601350',
    border: 'none',
    fontWeight: 500,
    cursor: 'pointer',
    boxShadow: 'none',
  },
  hovered: {
    background: '#f3e6f7',
    color: '#601350',
    border: 'none',
    fontWeight: 500,
    cursor: 'pointer',
    boxShadow: '0 0 0 2px #e1c6f7',
  },
  selected: {
    background: '#e1c6f7',
    color: '#601350',
    border: 'none',
    fontWeight: 600,
    cursor: 'pointer', 
  },
};
 
const TabButton = ({
  variant = 'enabled',
  type = 'text', // 'icon', 'iconText', 'text'
  label = 'Label',
  icon = <FormatListBulletedIcon fontSize="small" />,  
  ...props
}) => {
  const style = VARIANT_STYLE[variant] || VARIANT_STYLE.enabled;
  let startIcon = null;
  let content = label;
  let iconOnly = false;
  if (type === 'icon') {
    iconOnly = true;
    content = '';
  } else if (type === 'iconText') {
    startIcon = icon;
    content = label;
  } else if (type === 'text') {
    startIcon = null;
    content = label;
  }
  return (
    <Button
      disabled={variant === 'disabled'}
      startIcon={iconOnly ? null : startIcon}
      sx={{
        width: 'fit-content',
        height: 36,
        px: 2,
        borderRadius: 0,
        background: style.background,
        color: style.color,
        fontWeight: style.fontWeight,
        fontSize: 15,
        boxShadow: style.boxShadow,
        border: style.border,
        textTransform: 'none',
        cursor: style.cursor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
          background: variant === 'enabled' ? '#f3e6f7' : style.background,
          boxShadow: variant === 'enabled' ? '0 0 0 2px #e1c6f7' : style.boxShadow,
        },
        '&.Mui-disabled': {
          background: style.background,
          color: style.color,
          cursor: style.cursor,
        },
      }}
      disableElevation
      {...props}
    >
      {iconOnly ? (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
          {icon}
        </Box>
      ) : (
        content
      )}
    </Button>
  );
};

export default TabButton;
